import { MutationTree, ActionTree } from 'vuex'
import _get from 'lodash/get'
import instance from '../connection'

class State {
  organizations: any[] = []
  organizationList: any[] = []
  total: number = 0
  pagination = {
    current: 1 as number,
    pageSize: 10 as number,
    total: 0 as number
  }
  sorter = {
    field: '' as string,
    order: '' as string
  }
  search: string = ''
}

const getters = {}

const actions = <ActionTree<State, any>>{
  async getOrganizations({ commit, state }) {
    commit('updateOrganizations', await instance.get('/organization', {params: {
      page: state.pagination.current,
      limit: state.pagination.pageSize,
      sort: state.sorter.field,
      order: state.sorter.order,
      search: state.search
    }}))
  },
  async getOrganizationsList({ commit }) {
    commit('updateOrganizationList', await instance.get('/organization', {params: {
      all: true
    }}))
  },
  async deleteOrganization({ dispatch }, id) {
    await instance.delete('/organization/' + id)
    await dispatch('getOrganizationsList')
    return await dispatch('getOrganizations')
  },
  async updateOrganization({ dispatch }, organization:any) {
    await instance.put('/organization/' + organization.id, organization)
    await dispatch('getOrganizationsList')
    return await dispatch('getOrganizations')
  },
  async addOrganization({ dispatch }, organization:any) {
    await instance.post('/organization', organization)
    await dispatch('getOrganizationsList')
    return await dispatch('getOrganizations')
  },
}

const mutations = <MutationTree<State>>{
  updateOrganizations(state, organizations) {
    state.organizations = _get(organizations, 'data', [])
    state.total = _get(organizations, 'total', 0)
  },
  updateOrganizationList(state, organizations) {
    state.organizationList = _get(organizations, 'data', [])
  },
  updateOrganizationPagination(state, {current, pageSize, total}) {
    if (current) state.pagination.current = current
    if (pageSize) state.pagination.pageSize = pageSize
    if (total) state.pagination.total = total
  },
  updateOrganizationSorter(state, {field, order}) {
    if (field) state.sorter.field = field
    if (order) state.sorter.order = order
  },
  updateOrganizationSearchKey(state, search) {
    state.search = search
  }
}

export default {
  state: new State(),
  getters,
  actions,
  mutations
}